/* unplugin-vue-components disabled */import { render } from "./SchoolHeader.vue?vue&type=template&id=0b9a90bc&scoped=true"
import script from "./SchoolHeader.vue?vue&type=script&lang=js"
export * from "./SchoolHeader.vue?vue&type=script&lang=js"

import "./SchoolHeader.vue?vue&type=style&index=0&id=0b9a90bc&scoped=true&lang=css"

import exportComponent from "E:\\projects\\git\\company\\www_dixiang\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b9a90bc"]])

export default __exports__